function SideBar(): JSX.Element {
    return (
        <div
            id="sidebar"
            style={{
                left: 0,
                top: 0,
                position: "absolute",
                width: "300px",
                height: "100vh",
                zIndex: 100,
            }}
        >
            <div
                style={{
                    left: 0,
                    top: 0,
                    position: "absolute",
                    width: "300px",
                    height: "300px",
                    zIndex: 100,
                }}
            >
                <img
                    src="./search-flag.png"
                    alt="NVIDIA Omniverse"
                    width="300px"
                    height="300px"
                ></img>
            </div>
            <div
                style={{
                    left: 0,
                    top: 0,
                    position: "fixed",
                    backgroundColor: "#000",
                    width: "300px",
                    height: "100vh",
                    zIndex: 50,
                }}
            ></div>
        </div>
    );
}

export { SideBar };
